import type { QueensFacultyId } from './queensUniversityAcademics';

/** Not enrolled in any Queen's faculty. */
export const QUEENS_FACULTY_NONE = 'no-queens-faculty' as const;
export const QUEENS_FACULTY_OTHER = 'other' as const;
export const QUEENS_FACULTY_NA = 'NA' as const;

export type QueensFacultyPickerId =
  | QueensFacultyId
  | typeof QUEENS_FACULTY_NONE
  | typeof QUEENS_FACULTY_OTHER
  | typeof QUEENS_FACULTY_NA;

export const QUEENS_PROGRAM_NA = 'NA' as const;
/** Dropdown sentinel — not stored as the program value. */
export const QUEENS_PROGRAM_OTHER = '__program_other__' as const;

export type QueensProgramKind = 'list' | 'na' | 'other';

export const QUEENS_FACULTY_SPECIAL_OPTIONS: ReadonlyArray<{ value: QueensFacultyPickerId; label: string }> = [
  { value: QUEENS_FACULTY_NONE, label: "No faculty at Queen's" },
  { value: QUEENS_FACULTY_NA, label: 'N/A' },
  { value: QUEENS_FACULTY_OTHER, label: 'Other' },
];

export const QUEENS_PROGRAM_SPECIAL_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: QUEENS_PROGRAM_NA, label: 'N/A' },
  { value: QUEENS_PROGRAM_OTHER, label: 'Other' },
];

export function isQueensStandardFaculty(
  facultyId: QueensFacultyPickerId | null | undefined,
): facultyId is QueensFacultyId {
  if (!facultyId) return false;
  return (
    facultyId !== QUEENS_FACULTY_NONE &&
    facultyId !== QUEENS_FACULTY_OTHER &&
    facultyId !== QUEENS_FACULTY_NA
  );
}

export function facultyForcesProgramNa(facultyId: QueensFacultyPickerId | null | undefined): boolean {
  return facultyId === QUEENS_FACULTY_NONE || facultyId === QUEENS_FACULTY_NA;
}

export function queensFacultyPickerLabel(
  facultyId: QueensFacultyPickerId | null | undefined,
  facultyCustom: string,
  standardFacultyLabel: string | null,
): string | null {
  if (!facultyId) return null;
  if (facultyId === QUEENS_FACULTY_NONE) return "No faculty at Queen's";
  if (facultyId === QUEENS_FACULTY_NA) return 'N/A';
  if (facultyId === QUEENS_FACULTY_OTHER) {
    const trimmed = facultyCustom.trim();
    return trimmed ? trimmed : 'Other';
  }
  return standardFacultyLabel;
}
